module.exports = __webpack_public_path__ + "img/Apoptosis-GBM_10X_WTA.9403782a.png";